import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { WaButton } from "./ui";

export const MaterialDialog = ({ material: m, onClose }) => (
  <Dialog open={!!m} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="font-body max-w-4xl p-0 overflow-hidden bg-[#121214] border-[#C9A55C]/25 text-[#F3EEE4] rounded-none max-h-[90vh] overflow-y-auto" data-testid="material-dialog">
      {m && (
        <div className="grid md:grid-cols-2">
          <div className="aspect-square md:aspect-auto md:min-h-[480px] overflow-hidden">
            <img src={m.img} alt={m.name} className="w-full h-full object-cover" />
          </div>
          <div className="p-7 sm:p-10 flex flex-col">
            <span className="font-mono-x text-xs tracking-[0.3em] uppercase text-[#C9A55C]">{m.type}</span>
            <DialogTitle className="font-display font-light text-5xl mt-3 text-[#F3EEE4]" data-testid="material-dialog-title">{m.name}</DialogTitle>
            <DialogDescription className="text-[#CFC8BA] mt-5 leading-relaxed text-base">{m.note}</DialogDescription>
            <dl className="mt-8 divide-y divide-white/10 border-y border-white/10 text-sm">
              {[["Origjina", m.origin], ["Përfundimet", m.finish], ["Trashësia", "2 · 3 cm (të tjera me kërkesë)"]].map(([k, v]) => (
                <div key={k} className="flex justify-between gap-4 py-3">
                  <dt className="text-[#A8A196]">{k}</dt>
                  <dd className="text-right">{v}</dd>
                </div>
              ))}
            </dl>
            <WaButton topic={`materialin ${m.name}`} label={`Pyet për ${m.name}`} testId="material-dialog-whatsapp" className="mt-8 self-start" />
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
